/**
 * A "named version" is typically a test version of the game that's running at a specific non-default pathname in a
 * deplayed environment (such as "live"). If the game typically runs at triplejack.com/poker, it is not a "named version"
 * in that case. The "named version" of triplejack.com/poker-test would be "poker-test".
 */
import { isLocalhostEnvironment } from './utils';
const DEFAULT_DEPLOYED_PATHNAME = 'poker';
/**
 * SINGLETON ALERT!
 * null means it has been calculated (but is not set).
 * undefined means it has yet to be calculated.
 */
let namedVersion;
/**
 * Returns the non-default public path (if any) so it can be displayed in a floating header
 * to make it obvious that a special or testing version of the game is running.
 * Used in deployed environments ("live" for example).
 */
function calcNamedVersion() {
    if (isLocalhostEnvironment()) {
        // not relevent on localhost
        return null;
    }
    let publicPathFromEnv = process.env.PUBLIC_PATH;
    if (!publicPathFromEnv) {
        return null;
    }
    // remove leading and trailing slashes:
    while (publicPathFromEnv.startsWith('/')) {
        publicPathFromEnv = publicPathFromEnv.substring(1);
    }
    while (publicPathFromEnv.endsWith('/')) {
        publicPathFromEnv = publicPathFromEnv.substring(0, publicPathFromEnv.length - 1);
    }
    if (publicPathFromEnv && publicPathFromEnv !== DEFAULT_DEPLOYED_PATHNAME) {
        return publicPathFromEnv;
    }
    return null;
}
export function getNamedVersion() {
    if (namedVersion !== undefined) {
        return namedVersion;
    }
    const newNamedVersion = calcNamedVersion();
    namedVersion = newNamedVersion;
    return newNamedVersion;
}
export function isNamedVersion() {
    return !!getNamedVersion();
}
